import { schemaCalendarListItem } from '../user_calendar';
import { schemaResourceListItem } from '../user_resource';
import { z } from 'zod';
import { ProviderEnum, ProviderTypeEnum } from './enum';

export type AccountListItem = z.infer<typeof schemaAccountListItem>;
const schemaAccountListItem = z.object({
  id: z.number().int(),
  providerType: ProviderTypeEnum,
  email: z.string().email(),
  uid: z.string(),
  // FEにaccessTokenを返すとセキュリティ脆弱性になるためコメントアウトして残す
  // accessToken?: string;
});

export type EmailLookupItem = z.infer<typeof schemaEmailLookupItem>;
export const schemaEmailLookupItem = z.object({
  provider: ProviderEnum.nullable(),
});

export type SessionCreateBody = z.infer<typeof schemaSessionCreateBody>;
export const schemaSessionCreateBody = z.object({
  uid: z.string(),
  idToken: z.string(),
  accessToken: z.string(),
  refreshToken: z.string().nullable(),
  familyName: z.string().nullable(),
  givenName: z.string().nullable(),
  locale: z.string(),
  timeZone: z.string(),
});

export type UserAppItem = z.infer<typeof schemaUserAppItem>;
export const schemaUserAppItem = z.object({
  isZoom: z.boolean(),
  isGoogle: z.boolean(),
  isSlack: z.boolean(),
  isMicrosoft: z.boolean(),
  isTeams: z.boolean(),
  isSalesforce: z.boolean(),
  isHubSpot: z.boolean(),
  isNotion: z.boolean(),
  isGoogleSheet: z.boolean(),
});

export type AccountCalendarListItem = z.infer<
  typeof schemaAccountCalendarListItem
>;
export const schemaAccountCalendarListItem = z.object({
  id: z.number(),
  email: z.string(),
  calendars: z.array(schemaCalendarListItem),
  providerType: ProviderTypeEnum,
});

export type AccountResourceListItem = z.infer<
  typeof schemaAccountResourceListItem
>;
const schemaAccountResourceListItem = z.object({
  id: z.number(),
  email: z.string(),
  resources: z.array(schemaResourceListItem),
  providerType: ProviderTypeEnum,
});

export type IntegrationAccountListItem = z.infer<
  typeof schemaIntegrationAccountListItem
>;
export const schemaIntegrationAccountListItem = z.object({
  providerType: ProviderTypeEnum,
  updatedAt: z.string(),
  createdAt: z.string(),
  accessTokenExpiredAt: z.string(),
  tokenType: z.string().nullable(),
});
